import html2canvas from "html2canvas";

const DownloadQRCode = async (elementRef, cardNo) => {
  // Function to format the card number with spaces every 4 digits
  const formatCardNumber = (cardNo) => {
    return cardNo.replace(/(.{4})/g, "$1 ").trim();
  };

  if (elementRef.current) {
    // Create a temporary container to hold the QR code and text
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px"; // Move off-screen
    container.style.backgroundColor = "white";
    container.style.padding = "20px"; // Optional: Add padding for aesthetics
    container.style.display = "flex";
    container.style.flexDirection = "column";
    container.style.alignItems = "center";
    container.style.justifyContent = "center";
    container.style.textAlign = "center";
    document.body.appendChild(container);

    // Copy the QR code element into the container
    const qrClone = elementRef.current.cloneNode(true);
    container.appendChild(qrClone);

    // Add formatted text below the QR code
    const textElement = document.createElement("p");
    textElement.style.font = "20px Lato";
    textElement.style.textAlign = "center";
    textElement.style.marginTop = "10px";
    textElement.innerText = formatCardNumber(cardNo); // Use the formatted card number
    container.appendChild(textElement);

    // Capture the content of the container as a canvas
    const canvas = await html2canvas(container, { backgroundColor: "white" });
    const imgData = canvas.toDataURL("image/png");

    // Remove the temporary container
    document.body.removeChild(container);

    // Create a link element and trigger the download
    const link = document.createElement("a");
    link.href = imgData;
    link.download = `Maxicare-QR-${cardNo}.png`; // `${cardNo}_QRCode.png`
    link.click();
  }
};

export default DownloadQRCode;
